import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  bellnotification: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  notificationiconbutton: {
    width: "48px !important",
    height: "48px !important",
    border: "1px solid #dfe7ef !important",
    borderRadius: "999px !important",
    background: "#fff !important",
    color: "#314154 !important",
    boxShadow: "0 6px 14px rgba(18, 38, 63, 0.08) !important",
    "&:hover": {
      background: "#f7fbff !important",
    },
    "& svg": {
      color: "#314154",
    },
  },
  notificationpanel: {},
  notifycount: {
    "& .MuiBadge-badge": {
      color: "#fff",
    },
  },
}));

export default useStyles;
